/**
 * NOTE: If you're modifying items in this file, please add a member of the
 * Data team to your PR. Also, some of the values in these enums don't match
 * their keys on purpose in an effort to standardize on terminology used.
 *
 * For more detail on these values, please see the glossary:
 * http://go.atlassian.com/trello-analytics-glossary
 */

export enum Noun {
  ACCOUNT = 'account',
  ACTIVITY = 'activity',
  ACTIVITY_FEED = 'activity feed',
  ADD_MEMBERS_MENU = 'add members menu',
  ADD_MENU = 'add menu',
  ADMIN = 'admin',
  ATTACHMENT = 'attachment',
  AVATAR = 'avatar',
  BACKGROUND = 'background',
  BANNER = 'banner',
  BILLING = 'billing',
  BOARD = 'board',
  BOARD_BACKGROUND = 'board background',
  BOARD_SIDEBAR = 'board sidebar',
  BOARDS = 'boards',
  BOARDS_MENU = 'boards menu',
  BOARDS_PAGE = 'boards tab',
  BOARDS_TAB = 'boards tab',
  BUSINESS_CLASS = 'business class',
  CARD = 'card',
  CARD_BACK = 'card details', // Standardizing on terminology
  CARD_COMPOSER = 'card composer',
  CARD_DESCRIPTION = 'card description',
  CARD_DETAILS = 'card details',
  CARD_FRONT = 'card', // Standardizing on terminology
  CARD_SIDEBAR = 'card sidebar',
  CARDS = 'cards',
  CHANGE_TEAM_MENU = 'change team menu',
  CHECKLIST = 'checklist',
  CHECKLIST_ITEM = 'checklist item',
  COLLECTION = 'collection',
  COMMENT = 'comment',
  COMMENT_FIELD = 'comment field',
  COMMENT_TEXT = 'comment text',
  COPY_BOARD_MENU = 'copy board menu',
  CREATE_BOARD_MODAL = 'create board modal',
  CREATE_TEAM_MENU = 'create team menu',
  DUE_DATE = 'due date',
  EMAIL = 'email',
  EMAIL_FREQUENCY = 'email frequency',
  ENTERPRISE = 'enterprise',
  ENTERPRISE_DASHBOARD_MENU = 'enterprise dashboard menu',
  ERROR = 'error',
  GOLD = 'gold',
  HEADER = 'header',
  HEADER_TIPS = 'header tips',
  HELP = 'help',
  HIGHLIGHTS = 'highlights',
  HOME = 'home',
  INFO_ICON = 'info icon',
  INTRO_COMPONENT = 'intro component',
  INVITATION = 'invitation',
  LABEL = 'label',
  LANDING_TAB = 'landing tab',
  LANGUAGE = 'language',
  LINK = 'link',
  LIST = 'list',
  MEMBER = 'member',
  MEMBER_MENU = 'member menu',
  MEMBERS = 'members',
  MENU = 'menu',
  NOTIFICATIONS_MENU = 'notifications menu',
  ORGANIZATION = 'team', // Standardizing on terminology
  ORGANIZATIONS = 'teams', // Standardizing on terminology
  OVERFLOW_MENU = 'overflow menu',
  PERFORMANCE = 'performance',
  PLUGIN = 'power-up', // Standardizing on terminology
  PLUGINS = 'power-ups', // Standardizing on terminology
  POWER_UP = 'power-up',
  POWER_UPS = 'power-ups',
  POWER_UPS_DIRECTORY = 'power-ups directory',
  POWER_UPS_GET_STARTED = 'power-ups get started',
  POWER_UPS_LISTING = 'power-ups listing',
  PRIVATE = 'private',
  PROFILE = 'profile',
  PUBLIC = 'public',
  REACTIONS_PILE = 'reactions pile',
  REACTIONS_SELECTOR = 'reactions selector',
  SEARCH_INPUT = 'search input',
  SETTINGS = 'settings',
  SIDEBAR = 'sidebar',
  STICKER = 'sticker',
  TEAM = 'team',
  TEAM_FEEDS = 'team feeds',
  TEAM_MENU = 'team menu',
  TEAM_TAB = 'team tab',
  TEAMS = 'teams',
  TILE = 'tile',
  USER = 'member', // Standardizing on terminology
  USERS = 'members', // Standardizing on terminology
  VISIBILITY = 'visibility',
}

export enum Verb {
  ADDS = 'adds',
  ARCHIVES = 'archives',
  CHANGES = 'changes',
  CHECKS = 'checks',
  CLOSES = 'closes',
  COMPLETES = 'completes',
  COPIES = 'copies',
  DELETES = 'deletes',
  DISABLES = 'disables',
  DISMISSES = 'dismisses',
  DISPLAYS = 'shows', // Standardizing on terminology
  ENABLES = 'enables',
  FILTERS = 'filters',
  GENERATES = 'generates',
  HIDES = 'hides',
  INITIATES = 'initiates',
  JOINS = 'joins',
  LEAVES = 'leaves',
  LOADS_MORE = 'loads more',
  MARKS_AS_READ = 'marks as read',
  MARKS_AS_UNREAD = 'marks as unread',
  MOVES = 'moves',
  OPENS = 'opens',
  OPT_IN_TO = 'opt in to',
  OPT_OUT_OF = 'opt out of',
  ORDERS = 'orders',
  REMOVES = 'removes',
  REORDERS = 'reorders',
  REVOKES = 'revokes',
  SEARCHES = 'searches',
  SENDS = 'sends',
  SETS = 'sets',
  SHOWS = 'shows',
  SHOWS_ALL = 'shows all',
  SHOWS_FEWER = 'shows fewer',
  SHOWS_MORE = 'shows more',
  SHOWS_UNREAD = 'shows unread',
  SORTS = 'orders', // Standardizing on terminology
  STARS = 'stars',
  SUBSCRIBES = 'subscribes',
  UNCHECKS = 'unchecks',
  UNSTARS = 'unstars',
  UNSUBSCRIBES = 'unsubscribes',
  UNWATCHES = 'unsubscribes', // Standardizing on terminology
  VIEWS = 'views',
  WATCHES = 'subscribes', // Standardizing on terminology
}



// WEBPACK FOOTER //
// ./app/common/debug/analytics-constants.ts